import { Quote } from "lucide-react";

const QUOTES = [
  {
    body: "Saved my season — the late-summer mite alert came three days before I'd have thought to check. Mite count was already in the danger zone.",
    name: "Elena R.",
    detail: "6 hives · Vienna, Austria",
  },
  {
    body: "The voice journal is the killer feature. I used to lose 70% of my observations because writing in gloves is hopeless. Now everything's captured.",
    name: "Marcus K.",
    detail: "12 hives · Linz, Austria",
  },
  {
    body: "I run a small bee club and the co-keeper feature plus annual CSV report makes our end-of-year meeting trivially easy.",
    name: "Anna S.",
    detail: "Klagenfurt Apiary Club",
  },
  {
    body: "Started with the free plan to log my first colony — ended up upgrading the moment I added a second yard. Worth every euro.",
    name: "Tom B.",
    detail: "4 hives · Salzburg",
  },
  {
    body: "Hive Health Trends helped me realise my north-facing colonies were under-producing. Moved them in spring, harvest doubled.",
    name: "Sofia W.",
    detail: "8 hives · Tyrol",
  },
  {
    body: "The smart calendar is exactly what a 1st-year beekeeper needs — it gently reminds you what to do when, with proper reasoning.",
    name: "James P.",
    detail: "2 hives · Carinthia",
  },
];

export default function Testimonials() {
  return (
    <section
      id="spy-testimonials"
      className="relative max-w-6xl mx-auto px-6 py-24 sm:py-32"
      data-testid="landing-testimonials"
    >
      <header className="text-center max-w-2xl mx-auto mb-14">
        <div className="text-xs font-semibold uppercase tracking-[0.25em] text-amber-700 mb-3">Loved by beekeepers</div>
        <h2 className="font-display text-4xl sm:text-5xl font-light tracking-tight text-stone-900">
          From first-year hobbyists to bee-club veterans.
        </h2>
      </header>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        {QUOTES.map((q, i) => (
          <figure
            key={i}
            className="bg-white border border-stone-200 rounded-2xl p-6 flex flex-col"
            data-testid={`testimonial-${i}`}
          >
            <Quote className="w-5 h-5 text-amber-500 mb-3" />
            <blockquote className="text-sm text-stone-700 leading-relaxed flex-1">"{q.body}"</blockquote>
            <figcaption className="mt-4 pt-4 border-t border-stone-100">
              <div className="text-sm font-semibold text-stone-900">{q.name}</div>
              <div className="text-xs text-stone-500">{q.detail}</div>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}
